<template>
  <div class="row">
    <div class="col-12">

      <ValidationObserver ref="companyHealthCheck" slim>
        <form role="form" @submit.prevent="company_health_check_submit" class="row">

          <!-- Substitution, Direction and MOO -->
          <div class="col-12">
            <b-card header="Substitution, Direction and MOO" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Does your company have ultimate right of control over the tasks to be done? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does your company have ultimate right of control over the tasks to be done?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company right of Control" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_right_of_control" value="Yes" v-model="cct.company_right_of_control">
                    <div class="state p-danger-o">
                      <label>Yes - we will ensure that tasks are carried out in the correct manner inline with the company standards</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_right_of_control" value="No" v-model="cct.company_right_of_control">
                    <div class="state p-success-o">
                      <label>No - the Contractor has full control over every task being completed</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_right_of_control !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company Right of Control Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_right_of_control">Company Right of Control Detail</label>
                  <textarea type="text" v-model="cct.text_company_right_of_control" id="text_company_right_of_control"
                            name="text_company_right_of_control" class="form-input" :class="[classes, cct.company_right_of_control === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_right_of_control === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the contractors have the right to send a substitute? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the contractors have the right to send a substitute?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Right to Substitute" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_right_to_substitution" value="Yes" v-model="cct.contractor_right_to_substitution">
                    <div class="state p-success-o">
                      <label>Yes – have the right to send a substitute</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_right_to_substitution" value="No" v-model="cct.contractor_right_to_substitution">
                    <div class="state p-danger-o">
                      <label>No – no right to send someone in place</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_right_to_substitution !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Right to Substitute Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_right_to_substitution">Contractor Right to Substitute Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_right_to_substitution" id="text_contractor_right_to_substitution"
                            name="text_contractor_right_to_substitution" class="form-input" :class="[classes, cct.contractor_right_to_substitution === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_right_to_substitution === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Who is responsible for paying a substitute? -->
              <div class="row" v-if="cct.contractor_right_to_substitution === 'Yes'">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Who is responsible for paying a substitute?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Responsible for Paying Substitute" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="pay_substitute_responsibility" value="Company" v-model="cct.pay_substitute_responsibility">
                    <div class="state p-warning-o">
                      <label>We pay the replacement contractor direct</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="pay_substitute_responsibility" value="Contractor" v-model="cct.pay_substitute_responsibility">
                    <div class="state p-success-o">
                      <label>We would expect the contractor to sort the payments</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.pay_substitute_responsibility !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Responsible for Paying Substitute Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_pay_substitute_responsibility">Responsible for Paying Substitute Detail</label>
                  <textarea type="text" v-model="cct.text_pay_substitute_responsibility" id="text_pay_substitute_responsibility"
                            name="text_pay_substitute_responsibility" class="form-input" :class="[classes, cct.pay_substitute_responsibility === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.pay_substitute_responsibility === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do you the client have the right to reject a substitute? -->
              <div class="row" v-if="cct.contractor_right_to_substitution === 'Yes'">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do you the client have the right to reject a substitute?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company Right to Reject Substitute" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_right_to_reject_substitute" value="No" v-model="cct.company_right_to_reject_substitute">
                    <div class="state p-danger-o">
                      <label>No - we would accept them</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_right_to_reject_substitute" value="Yes" v-model="cct.company_right_to_reject_substitute">
                    <div class="state p-success-o">
                      <label>Yes - we can reject them</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_right_to_reject_substitute !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company Right to Reject Substitute Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_right_to_reject_substitute">Company Right to Reject Substitute Detail</label>
                  <textarea type="text" v-model="cct.text_company_right_to_reject_substitute" id="text_company_right_to_reject_substitute"
                            name="text_company_right_to_reject_substitute" class="form-input" :class="[classes, cct.company_right_to_reject_substitute === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_right_to_reject_substitute === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the contractors have set hours? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the contractors have set hours?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors have set hours" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_set_hours" value="Yes" v-model="cct.contractor_set_hours">
                    <div class="state p-warning-o">
                      <label>Yes - set hours in line with the site opening times</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_set_hours" value="No" v-model="cct.contractor_set_hours">
                    <div class="state p-success-o">
                      <label>No - contractors can chose working hours</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_set_hours !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors have set hours Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_set_hours">Contractors have set hours Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_set_hours" id="text_contractor_set_hours"
                            name="text_contractor_set_hours" class="form-input" :class="[classes, cct.contractor_set_hours === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_set_hours === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Have any contractors sent alternative labour when they are unable to work? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Have any contractors sent alternative labour when they are unable to work?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors sent alternative labour" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="historic_contractor_sent_alternative_labour" value="Yes_No_Sub" v-model="cct.historic_contractor_sent_alternative_labour">
                    <div class="state p-warning-o">
                      <label>Yes – they have the right but never had a substitution</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="historic_contractor_sent_alternative_labour" value="Yes" v-model="cct.historic_contractor_sent_alternative_labour">
                    <div class="state p-success-o">
                      <label>Yes - previously had contractors sending others to work in their place</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="historic_contractor_sent_alternative_labour" value="No" v-model="cct.historic_contractor_sent_alternative_labour">
                    <div class="state p-danger-o">
                      <label>No - this doesn't happen</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.historic_contractor_sent_alternative_labour !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors sent alternative labour Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_historic_contractor_sent_alternative_labour">Contractors have set hours Detail</label>
                  <textarea type="text" v-model="cct.text_historic_contractor_sent_alternative_labour" id="text_historic_contractor_sent_alternative_labour"
                            name="text_historic_contractor_sent_alternative_labour"
                            class="form-input" :class="[classes, cct.historic_contractor_sent_alternative_labour === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.historic_contractor_sent_alternative_labour === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Could the contractors engage additional support (contractors) at their own expense? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Could the contractors engage additional support (contractors) at their own expense?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors engage additional support" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_engage_additional_support_own_cost" value="No" v-model="cct.contractors_engage_additional_support_own_cost">
                    <div class="state p-danger-o">
                      <label>No - the company would bring in any additional labour</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_engage_additional_support_own_cost" value="Yes" v-model="cct.contractors_engage_additional_support_own_cost">
                    <div class="state p-success-o">
                      <label>Yes – the contractor would be responsible to find any additional support</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractors_engage_additional_support_own_cost !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors engage additional support Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractors_engage_additional_support_own_cost">Contractors engage additional support Detail</label>
                  <textarea type="text" v-model="cct.text_contractors_engage_additional_support_own_cost" id="text_contractors_engage_additional_support_own_cost"
                            name="text_contractors_engage_additional_support_own_cost"
                            class="form-input" :class="[classes, cct.contractors_engage_additional_support_own_cost === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractors_engage_additional_support_own_cost === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Can the contractor decline work offered from you? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Can the contractor decline work offered from you?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor decline work" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_decline_work" value="Yes" v-model="cct.contractor_decline_work">
                    <div class="state p-success-o">
                      <label>Yes - and we do not have to provide work beyond the initial contract</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_decline_work" value="No" v-model="cct.contractor_decline_work">
                    <div class="state p-danger-o">
                      <label>No - we dictate what sites they are working on and when</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_decline_work !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor decline work Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_decline_work">Contractor decline work Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_decline_work" id="text_contractor_decline_work"
                            name="text_contractor_decline_work" class="form-input" :class="[classes, cct.contractor_decline_work === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_decline_work === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Right to Work -->
          <div class="col-12">
            <b-card header="Right to Work" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Does your company carry out right to work checks for all contractors you engage with? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does your company carry out right to work checks for all contractors you engage with?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company cary out Right to Work Checks" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_carry_out_right_to_work_checks" value="No" v-model="cct.company_carry_out_right_to_work_checks">
                    <div class="state p-danger-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_carry_out_right_to_work_checks" value="No_Current_Provider" v-model="cct.company_carry_out_right_to_work_checks">
                    <div class="state p-warning-o">
                      <label>No - Our current recruitment agency/outsourced provider deal with this</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_carry_out_right_to_work_checks" value="Yes" v-model="cct.company_carry_out_right_to_work_checks">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_carry_out_right_to_work_checks !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company cary out Right to Work Checks Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_carry_out_right_to_work_checks">Company Right of Control Detail</label>
                  <textarea type="text" v-model="cct.text_company_carry_out_right_to_work_checks" id="text_company_carry_out_right_to_work_checks"
                            name="text_company_carry_out_right_to_work_checks"
                            class="form-input" :class="[classes, cct.company_carry_out_right_to_work_checks === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.company_carry_out_right_to_work_checks === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- How do you ensure non UK workers are eligible to work in the UK? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">How do you ensure non UK workers are eligible to work in the UK?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Responsible for non UK workers eligibility to work" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="how_check_non_uk_right_to_work" value="No_Checks" v-model="cct.how_check_non_uk_right_to_work">
                    <div class="state p-danger-o">
                      <label>No Checks Performed</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="how_check_non_uk_right_to_work" value="ID" v-model="cct.how_check_non_uk_right_to_work">
                    <div class="state p-danger-o">
                      <label>We check their ID</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="how_check_non_uk_right_to_work" value="R2W_Code" v-model="cct.how_check_non_uk_right_to_work">
                    <div class="state p-success-o">
                      <label>We ensure that the workers provide settlement code or biometric code along with their ID ahead of starting</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.how_check_non_uk_right_to_work !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Responsible for non UK workers eligibility to work Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_carry_out_right_to_work_checks">Responsible for non UK workers eligibility to work Detail</label>
                  <textarea type="text" v-model="cct.text_how_check_non_uk_right_to_work" id="text_how_check_non_uk_right_to_work"
                            name="text_how_check_non_uk_right_to_work" class="form-input" :class="[classes, cct.how_check_non_uk_right_to_work === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.how_check_non_uk_right_to_work === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Financial Risk -->
          <div class="col-12">
            <b-card header="Financial Risk" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Do the contractors carry their own insurance? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the contractors carry their own insurance?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors have own Insurance" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_have_own_insurance" value="Yes" v-model="cct.contractors_have_own_insurance">
                    <div class="state p-success-o">
                      <label>Yes - it is the contractors liability to insure themselves</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_have_own_insurance" value="No_Company_Insurance" v-model="cct.contractors_have_own_insurance">
                    <div class="state p-danger-o">
                      <label>No - the contractors fall under our insurance</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractors_have_own_insurance !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors have own Insurance Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractors_have_own_insurance">Contractors have own Insurance Detail</label>
                  <textarea type="text" v-model="cct.text_contractors_have_own_insurance" id="text_contractors_have_own_insurance"
                            name="text_contractors_have_own_insurance" class="form-input" :class="[classes, cct.contractors_have_own_insurance === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractors_have_own_insurance === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the contractors invoice for the work? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the contractors invoice for the work?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors Invoice for Work" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_invoice_for_work" value="Yes" v-model="cct.contractors_invoice_for_work">
                    <div class="state p-success-o">
                      <label>Yes - they invoice for works carried out at the end of each week</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_invoice_for_work" value="No" v-model="cct.contractors_invoice_for_work">
                    <div class="state p-danger-o">
                      <label>No - we calculate the hours worked on the timesheet and submit the work</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractors_invoice_for_work !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors Invoice for Work Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractors_invoice_for_work">Contractors Invoice for Work Detail</label>
                  <textarea type="text" v-model="cct.text_contractors_invoice_for_work" id="text_contractors_invoice_for_work"
                            name="text_contractors_invoice_for_work" class="form-input" :class="[classes, cct.contractors_invoice_for_work === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractors_invoice_for_work === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Is there a risk of financial loss to the contractors? (not just unpaid wages) -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Is there a risk of financial loss to the contractors? (not just unpaid wages)</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors financial risk" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_financial_risk" value="Yes" v-model="cct.contractors_financial_risk">
                    <div class="state p-success-o">
                      <label>Yes - they must complete any errors within their own time and unpaid</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractors_financial_risk" value="No" v-model="cct.contractors_financial_risk">
                    <div class="state p-danger-o">
                      <label>No - any errors get rectified as they go</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractors_financial_risk !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors financial risk Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractors_financial_risk">Contractors financial risk Detail</label>
                  <textarea type="text" v-model="cct.text_contractors_financial_risk" id="text_contractors_financial_risk"
                            name="text_contractors_financial_risk" class="form-input" :class="[classes, cct.contractors_financial_risk === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractors_financial_risk === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- How will the contractor be paid for the work, Daily, hourly or Price? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">How will the contractor be paid for the work, Daily, hourly or Price?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Pay Type" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_pay_type" value="Price" v-model="cct.contractor_pay_type">
                    <div class="state p-success-o">
                      <label>Price work</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_pay_type" value="Daily" v-model="cct.contractor_pay_type">
                    <div class="state p-warning-o">
                      <label>Daily Rate</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_pay_type" value="Hourly" v-model="cct.contractor_pay_type">
                    <div class="state p-warning-o">
                      <label>Hourly Rate</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_pay_type !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Pay Type Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_pay_type">Contractor Pay Type Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_pay_type" id="text_contractor_pay_type"
                            name="text_contractor_pay_type" class="form-input" :class="[classes, cct.contractor_pay_type === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_pay_type === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Contracts -->
          <div class="col-12">
            <b-card header="Contracts" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Is a contract provided for every job undertaken by a Contractor? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Is a contract provided for every job undertaken by a Contractor?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Contract for Every Job" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_job" value="No_Contract" v-model="cct.contractor_contract_for_every_job">
                    <div class="state p-danger-o">
                      <label>No - a contract is not provided</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_job" value="No_At_Start" v-model="cct.contractor_contract_for_every_job">
                    <div class="state p-danger-o">
                      <label>No - an initial contract is provided when they start</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_job" value="No_Yearly" v-model="cct.contractor_contract_for_every_job">
                    <div class="state p-warning-o">
                      <label>No - a contract is provided and renewed each year</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_job" value="Yes" v-model="cct.contractor_contract_for_every_job">
                    <div class="state p-success-o">
                      <label>Yes - a contract is provided for every job given</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_contract_for_every_job !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Contract for Every Job Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_contract_for_every_job">Contractor Contract for Every Job Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_contract_for_every_job" id="text_contractor_contract_for_every_job"
                            name="text_contractor_contract_for_every_job" class="form-input" :class="[classes, cct.contractor_contract_for_every_job === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_contract_for_every_job === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Does a Contractor who works on multiple sites at the same time receive a contract relevant to each location? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does a Contractor who works on multiple sites at the same time receive a contract relevant to each location?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Contract for each Site" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_site" value="No" v-model="cct.contractor_contract_for_every_site">
                    <div class="state p-danger-o">
                      <label>No - they may have to be on several sites each day it isn’t realistic</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_for_every_site" value="Yes" v-model="cct.contractor_contract_for_every_site">
                    <div class="state p-success-o">
                      <label>Yes - they will always be finished up on their initial site and provided with a new contract</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_contract_for_every_site !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Contract for each Site Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_contract_for_every_site">Contractor Contract for each Site Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_contract_for_every_site" id="text_contractor_contract_for_every_site"
                            name="text_contractor_contract_for_every_site" class="form-input" :class="[classes, cct.contractor_contract_for_every_site === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_contract_for_every_site === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the current contracts provided have fixed end dates? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the current contracts provided have fixed end dates?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Contract have Fixed End Date" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_fixed_end_date" value="No" v-model="cct.contractor_contract_fixed_end_date">
                    <div class="state p-danger-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_contract_fixed_end_date" value="Yes" v-model="cct.contractor_contract_fixed_end_date">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_contract_fixed_end_date !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Contract have Fixed End Date Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_contract_fixed_end_date">Contractor Contract have Fixed End Date Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_contract_fixed_end_date" id="text_contractor_contract_fixed_end_date"
                            name="text_contractor_contract_fixed_end_date" class="form-input" :class="[classes, cct.contractor_contract_fixed_end_date === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_contract_fixed_end_date === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Does your company know who will be performing work? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does your company know who will be performing work?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company know who performs work" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_know_who_will_complete_work" value="Yes" v-model="cct.company_know_who_will_complete_work">
                    <div class="state p-warning-o">
                      <label>Yes - we will typically engage the individual for the work</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_know_who_will_complete_work" value="No" v-model="cct.company_know_who_will_complete_work">
                    <div class="state p-success-o">
                      <label>No - we use a recruitment agency, and the individual turns up on site on the day</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_know_who_will_complete_work" value="Sometimes" v-model="cct.company_know_who_will_complete_work">
                    <div class="state p-warning-o">
                      <label>Sometimes - mixture of the above</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_know_who_will_complete_work !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company know who performs work Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_know_who_will_complete_work">Company know who performs work Detail</label>
                  <textarea type="text" v-model="cct.text_company_know_who_will_complete_work" id="text_company_know_who_will_complete_work"
                            name="text_company_know_who_will_complete_work" class="form-input"
                            :class="[classes, cct.company_know_who_will_complete_work === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.company_know_who_will_complete_work === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Is notice given to terminate service or to lay anyone off? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Is notice given to terminate service or to lay anyone off?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Notice Given" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_notice_given" value="No_Notice" v-model="cct.contractor_notice_given">
                    <div class="state p-success-o">
                      <label>No – no notice needs to be given</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_notice_given" value="No_Agency" v-model="cct.contractor_notice_given">
                    <div class="state p-success-o">
                      <label>No – we advise the agency who does this for us</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_notice_given" value="Yes" v-model="cct.contractor_notice_given">
                    <div class="state p-danger-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_notice_given !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Notice Given Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_notice_given">Notice Given Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_notice_given" id="text_contractor_notice_given"
                            name="text_contractor_notice_given" class="form-input" :class="[classes, cct.contractor_notice_given === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_notice_given === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do your contracts stop the contractor from doing similar work for other companies? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do your contracts stop the contractor from doing similar work for other companies?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Stop Contractor Working for other Companies" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_work_for_other_companies" value="Yes" v-model="cct.contractor_work_for_other_companies">
                    <div class="state p-danger-o">
                      <label>Yes - typically the contractor only works for us</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_work_for_other_companies" value="No" v-model="cct.contractor_work_for_other_companies">
                    <div class="state p-success-o">
                      <label>No - they are free to complete work for any other client</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_work_for_other_companies !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Stop Contractor Working for other Companies Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_work_for_other_companies">Stop Contractor Working for other Companies Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_work_for_other_companies" id="text_contractor_work_for_other_companies"
                            name="text_contractor_work_for_other_companies"
                            class="form-input" :class="[classes, cct.contractor_work_for_other_companies === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_work_for_other_companies === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- How would the contractor introduce themselves to your consumers or suppliers? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">How would the contractor introduce themselves to your consumers or suppliers?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor introduce to Consumers/Suppliers" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_introduce_to_consumer_supplier" value="Work_For_Company" v-model="cct.contractor_introduce_to_consumer_supplier">
                    <div class="state p-danger-o">
                      <label>The contractor would say they work for the company</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_introduce_to_consumer_supplier" value="Worker_Engaged_By_Third_Party"
                           v-model="cct.contractor_introduce_to_consumer_supplier">
                    <div class="state p-success-o">
                      <label>The contractor would say they are engaged via a third party (e.g. Recruitment/Payroll Company)</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_introduce_to_consumer_supplier !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor introduce to Consumers/Suppliers Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_introduce_to_consumer_supplier">Contractor introduce to Consumers/Suppliers Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_introduce_to_consumer_supplier" id="text_contractor_introduce_to_consumer_supplier"
                            name="text_contractor_introduce_to_consumer_supplier"
                            class="form-input" :class="[classes, cct.contractor_introduce_to_consumer_supplier === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_introduce_to_consumer_supplier === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Benefits -->
          <div class="col-12">
            <b-card header="Benefits" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Do you arrange training courses? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do you arrange training courses?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company arrange Training" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_arrange_training" value="Yes" v-model="cct.company_arrange_training">
                    <div class="state p-warning-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_arrange_training" value="No" v-model="cct.company_arrange_training">
                    <div class="state p-success-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_arrange_training !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company arrange Training Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_arrange_training">Company arrange Training Detail</label>
                  <textarea type="text" v-model="cct.text_company_arrange_training" id="text_company_arrange_training"
                            name="text_company_arrange_training" class="form-input" :class="[classes, cct.company_arrange_training === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_arrange_training === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Does the company pay for training? -->
              <div class="row" v-if="cct.company_arrange_training === 'Yes'">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does the company pay for training?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company pay for training" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_pay_for_training" value="No" v-model="cct.company_pay_for_training">
                    <div class="state p-success-o">
                      <label>No – contractor pays for any training themselves</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_pay_for_training" value="Yes" v-model="cct.company_pay_for_training">
                    <div class="state p-danger-o">
                      <label>Yes - pay for any training carried out</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_pay_for_training !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company pay for training Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_pay_for_training">Company pay for training Detail</label>
                  <textarea type="text" v-model="cct.text_company_pay_for_training" id="text_company_pay_for_training"
                            name="text_company_pay_for_training" class="form-input" :class="[classes, cct.company_pay_for_training === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_pay_for_training === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the contractors use holiday request forms? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the contractors use holiday request forms?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors use Holiday Request Forms" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_use_holiday_request_form" value="Yes" v-model="cct.contractor_use_holiday_request_form">
                    <div class="state p-danger-o">
                      <label>Yes - contractors apply for holiday leave</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_use_holiday_request_form" value="No" v-model="cct.contractor_use_holiday_request_form">
                    <div class="state p-success-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_use_holiday_request_form !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors use Holiday Request Forms Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_use_holiday_request_form">Contractors use Holiday Request Forms Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_use_holiday_request_form" id="text_contractor_use_holiday_request_form"
                            name="text_contractor_use_holiday_request_form"
                            class="form-input" :class="[classes, cct.contractor_use_holiday_request_form === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_use_holiday_request_form === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do you provide the contractors with Vans? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do you provide the contractors with Vans?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company provide contractor with Vans" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_provide_vans" value="Yes" v-model="cct.company_provide_vans">
                    <div class="state p-warning-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_provide_vans" value="No" v-model="cct.company_provide_vans">
                    <div class="state p-success-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_provide_vans !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company provide contractor with Vans Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_provide_vans">Company provide contractor with Vans Detail</label>
                  <textarea type="text" v-model="cct.text_company_provide_vans" id="text_company_provide_vans"
                            name="text_company_provide_vans" class="form-input" :class="[classes, cct.company_provide_vans === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_provide_vans === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Does the contractor pay for these vans? -->
              <div class="row" v-if="cct.company_provide_vans === 'Yes'">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Does the contractor pay for these vans?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor pay for Van" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_pay_for_company_vans" value="No" v-model="cct.contractor_pay_for_company_vans">
                    <div class="state p-warning-o">
                      <label>No - paid for by the client</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_pay_for_company_vans" value="Yes" v-model="cct.contractor_pay_for_company_vans">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_pay_for_company_vans !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor pay for Van Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_pay_for_company_vans">Contractor pay for Van Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_pay_for_company_vans" id="text_contractor_pay_for_company_vans"
                            name="text_contractor_pay_for_company_vans" class="form-input" :class="[classes, cct.contractor_pay_for_company_vans === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_pay_for_company_vans === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- How are the vans used? -->
              <div class="row" v-if="cct.company_provide_vans === 'Yes'">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">How are the vans used?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="How are the vans used" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_vans_how_used" value="Work" v-model="cct.company_vans_how_used">
                    <div class="state p-success-o">
                      <label>Contractors drive from the yard and use them within working day</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_vans_how_used" value="Personal" v-model="cct.company_vans_how_used">
                    <div class="state p-danger-o">
                      <label>Contractors take them home each evening</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_vans_how_used !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="How are the vans used Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_vans_how_used">How are the vans used Detail</label>
                  <textarea type="text" v-model="cct.text_company_vans_how_used" id="text_company_vans_how_used"
                            name="text_company_vans_how_used" class="form-input" :class="[classes, cct.company_vans_how_used === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_vans_how_used === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Will you provide the contractor with paid-for corporate benefits? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Will you provide the contractor with paid-for corporate benefits?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company provide Corporate Benefits" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_provided_corporate_benefits" value="No" v-model="cct.contractor_provided_corporate_benefits">
                    <div class="state p-success-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_provided_corporate_benefits" value="Yes" v-model="cct.contractor_provided_corporate_benefits">
                    <div class="state p-danger-o">
                      <label>Yes - e.g. Vans, Paid Leave, Equipment, Tools, Materials, etc</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_provided_corporate_benefits !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company provide Corporate Benefits Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_provided_corporate_benefits">Company provide Corporate Benefits Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_provided_corporate_benefits" id="text_contractor_provided_corporate_benefits"
                            name="text_contractor_provided_corporate_benefits"
                            class="form-input" :class="[classes, cct.contractor_provided_corporate_benefits === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_provided_corporate_benefits === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Duties -->
          <div class="col-12">
            <b-card header="Duties" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Will any of the contractors be 'Office Holders'? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Will any of the contractors be 'Office Holders'?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractors be 'Office Holders'" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_office_holder" value="No" v-model="cct.contractor_office_holder">
                    <div class="state p-success-o">
                      <label>No - all construction</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_office_holder" value="Some" v-model="cct.contractor_office_holder">
                    <div class="state p-warning-o">
                      <label>There will be some office holders</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_office_holder" value="Yes" v-model="cct.contractor_office_holder">
                    <div class="state p-danger-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_office_holder !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractors be 'Office Holders' Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_office_holder">Contractors be 'Office Holders' Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_office_holder" id="text_contractor_office_holder"
                            name="text_contractor_office_holder" class="form-input" :class="[classes, cct.contractor_office_holder === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_office_holder === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do contractors provide their service through a limited company or as a sole trader? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do contractors provide their service through a limited company or as a sole trader?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor Ltd or Sole Trader Required" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_ltd_sole_trader" value="Limited_Company" v-model="cct.contractor_ltd_sole_trader">
                    <div class="state p-success-o">
                      <label>Limited Company</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_ltd_sole_trader" value="Sole_Trader" v-model="cct.contractor_ltd_sole_trader">
                    <div class="state p-success-o">
                      <label>Sole Trader</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_ltd_sole_trader" value="Both" v-model="cct.contractor_ltd_sole_trader">
                    <div class="state p-success-o">
                      <label>A mixture of the above</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_personal_service_required !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor Ltd or Sole Trader Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_ltd_sole_trader">Contractor Ltd or Sole Trader Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_ltd_sole_trader" id="text_contractor_ltd_sole_trader"
                            name="text_contractor_ltd_sole_trader"
                            class="form-input" :class="[classes, cct.contractor_ltd_sole_trader === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_ltd_sole_trader === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Is personal service required? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Is personal service required?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Personal Service Required" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_personal_service_required" value="Yes" v-model="cct.contractor_personal_service_required">
                    <div class="state p-danger-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_personal_service_required" value="No" v-model="cct.contractor_personal_service_required">
                    <div class="state p-success-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_personal_service_required !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Personal Service Required Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_personal_service_required">Personal Service Required Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_personal_service_required" id="text_contractor_personal_service_required"
                            name="text_contractor_personal_service_required"
                            class="form-input" :class="[classes, cct.contractor_personal_service_required === null ? 'disabled' : '']" rows="3"
                            :disabled="cct.contractor_personal_service_required === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <!-- Working Arrangement -->
          <div class="col-12">
            <b-card header="Working Arrangement" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Do contractors have to buy equipment before the company pays them? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-0 font-weight-bold">Do contractors have to buy equipment before the company pays them?</p>
                  <p class="mb-2" style="font-size: 0.65rem; font-style: italic">This can include heavy machinery or high-cost specialist equipment.</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor buy equipment before company pays" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_buy_equipment" value="Yes" v-model="cct.contractor_buy_equipment">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_buy_equipment" value="No" v-model="cct.contractor_buy_equipment">
                    <div class="state p-danger-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_buy_equipment !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor buy equipment before company pays Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_buy_equipment">Contractor buy equipment before company pays Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_buy_equipment" id="text_contractor_buy_equipment"
                            name="text_contractor_buy_equipment" class="form-input" :class="[classes, cct.contractor_buy_equipment === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_buy_equipment === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do contractors have to buy materials before the company pays them? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-0 font-weight-bold">Do contractors have to buy materials before the company pays them?</p>
                  <p class="mb-2" style="font-size: 0.65rem; font-style: italic">This can include items that form a lasting part of the work, or are left behind when the worker
                    leaves.</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor buy materials before company pays" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_buy_materials" value="Yes" v-model="cct.contractor_buy_materials">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_buy_materials" value="No" v-model="cct.contractor_buy_materials">
                    <div class="state p-danger-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_buy_materials !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor buy materials before company pays Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_buy_materials">Contractor buy materials before company pays Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_buy_materials" id="text_contractor_buy_materials"
                            name="text_contractor_buy_materials" class="form-input" :class="[classes, cct.contractor_buy_materials === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_buy_materials === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Will contractors have to fund any other costs before the company pays them?? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-0 font-weight-bold">Will contractors have to fund any other costs before the company pays them?</p>
                  <p class="mb-2" style="font-size: 0.65rem; font-style: italic">This can include non-commuting travel or accommodation, or external business premises for this
                    work only.</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Contractor any other costs before company pays" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_fund_any_other_cost" value="Yes" v-model="cct.contractor_fund_any_other_cost">
                    <div class="state p-success-o">
                      <label>Yes</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_fund_any_other_cost" value="No" v-model="cct.contractor_fund_any_other_cost">
                    <div class="state p-danger-o">
                      <label>No</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_buy_materials !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Contractor any other costs before company pays Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_fund_any_other_cost">Contractor any other costs before company pays Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_fund_any_other_cost" id="text_contractor_fund_any_other_cost"
                            name="text_contractor_fund_any_other_cost" class="form-input" :class="[classes, cct.contractor_fund_any_other_cost === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_fund_any_other_cost === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>

              <!-- Do you provide PPE? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do you provide PPE?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="Company provide PPE" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_provide_ppe" value="Yes" v-model="cct.company_provide_ppe">
                    <div class="state p-danger-o">
                      <label>Yes - all contractors are provided with the relevant PPE</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="company_provide_ppe" value="No" v-model="cct.company_provide_ppe">
                    <div class="state p-success-o">
                      <label>No - contractors provide their own PPE</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.company_provide_ppe !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="Company provide PPE Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_company_provide_ppe">Company provide PPE Detail</label>
                  <textarea type="text" v-model="cct.text_company_provide_ppe" id="text_company_provide_ppe"
                            name="text_company_provide_ppe" class="form-input" :class="[classes, cct.company_provide_ppe === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.company_provide_ppe === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- Do the CIS contractors work alongside PAYE employees? -->
              <div class="row">
                <div class="col-12">
                  <p class="mb-2 font-weight-bold">Do the CIS contractors work alongside PAYE employees?</p>
                </div>
                <ValidationProvider rules="" v-slot="{errors, classes}" name="CIS Contractors work alongside PAYE" tag="div" class="col-xl-6 form-group">
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_work_alongside_paye" value="Yes" v-model="cct.contractor_work_alongside_paye">
                    <div class="state p-warning-o">
                      <label>Yes - there is a mixture of both PAYE</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" name="contractor_work_alongside_paye" value="No" v-model="cct.contractor_work_alongside_paye">
                    <div class="state p-success-o">
                      <label>No - all self-employed within the company</label>
                    </div>
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="cct.contractor_work_alongside_paye !== null ? 'required' : ''" v-slot="{errors, classes}"
                                    name="CIS Contractors work alongside PAYE Detail" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="text_contractor_work_alongside_paye">CIS Contractors work alongside PAYE Detail</label>
                  <textarea type="text" v-model="cct.text_contractor_work_alongside_paye" id="text_contractor_work_alongside_paye"
                            name="text_contractor_work_alongside_paye" class="form-input" :class="[classes, cct.contractor_work_alongside_paye === null ? 'disabled' : '']"
                            rows="3" :disabled="cct.contractor_work_alongside_paye === null"></textarea>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </b-card>
          </div>

          <div class="col-12">
            <div class="row signature-container">
              <div class="col-12 signature-wrapper">
                <h5>Signature</h5>
                <SignaturePad ref="signature_sign" @signature-updated="handleSignatureUpdated('signature_sign', $event)" />
                <input type="hidden" v-model="cct.signature_sign" name="signature_sign" id="signature_sign" placeholder="Sign" required/>
                <!-- <img :src="cct.signature_sign" id="signature_sign_result" /> -->
              </div>
              <div class="col-12 signature-wrapper">
                <h5>Date</h5>
                <SignaturePad ref="signature_date" @signature-updated="handleSignatureUpdated('signature_date', $event)" />
                <input type="hidden" v-model="cct.signature_date" name="signature_date" id="signature_date" placeholder="Data" required/>
                <!-- <img :src="cct.signature_date" id="signature_date_result" /> -->
              </div>
            </div>
          </div>


          <div class="col-lg-6">
            <button class="btn orcaBtn grey_bg sm_btn w-100" @click.prevent="save_for_later" :disabled="updating" v-if="!saving">
              <span v-if="updating" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Updating Health Check ...</span>
              <span v-else>Update Health Check</span>
            </button>
          </div>
          <div class="col-lg-6">
            <button type="submit" class="btn orcaBtn sm_btn w-100" :class="check_completed ? '' : 'disabled'" :disabled="!check_completed && !saving" v-if="!updating">
              <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Completing Health Check ...</span>
              <span v-else>Complete Health Check</span>
            </button>
          </div>

        </form>
      </ValidationObserver>

    </div>
  </div>
</template>

<script>
import PrettyCheckbox from 'pretty-checkbox-vue';
import Vue from 'vue';
import SignaturePad from 'pages/companies/record/compliance/SignaturePad'; 

Vue.use(PrettyCheckbox);

export default {
  name: "health_check",
  props: ['health_check', 'check_completed'],
  components: {
    SignaturePad
  },
  data() {
    return {
      cct: {
        // substitution, direction and moo
        company_right_of_control: null,
        text_company_right_of_control: '',
        contractor_right_to_substitution: null,
        text_contractor_right_to_substitution: '',
        pay_substitute_responsibility: null,
        text_pay_substitute_responsibility: '',
        company_right_to_reject_substitute: null,
        text_company_right_to_reject_substitute: '',
        contractor_set_hours: null,
        text_contractor_set_hours: '',
        historic_contractor_sent_alternative_labour: null,
        text_historic_contractor_sent_alternative_labour: '',
        contractors_engage_additional_support_own_cost: null,
        text_contractors_engage_additional_support_own_cost: '',
        contractor_decline_work: null,
        text_contractor_decline_work: '',
        // right to work
        company_carry_out_right_to_work_checks: null,
        text_company_carry_out_right_to_work_checks: '',
        how_check_non_uk_right_to_work: null,
        text_how_check_non_uk_right_to_work: '',
        // financial risk
        contractors_have_own_insurance: null,
        text_contractors_have_own_insurance: '',
        contractors_invoice_for_work: null,
        text_contractors_invoice_for_work: '',
        contractors_financial_risk: null,
        text_contractors_financial_risk: '',
        contractor_pay_type: null,
        text_contractor_pay_type: '',
        // contracts
        contractor_contract_for_every_job: null,
        text_contractor_contract_for_every_job: '',
        contractor_contract_for_every_site: null,
        text_contractor_contract_for_every_site: '',
        contractor_contract_fixed_end_date: null,
        text_contractor_contract_fixed_end_date: '',
        company_know_who_will_complete_work: null,
        text_company_know_who_will_complete_work: '',
        contractor_notice_given: null,
        text_contractor_notice_given: '',
        contractor_work_for_other_companies: null,
        text_contractor_work_for_other_companies: '',
        contractor_introduce_to_consumer_supplier: null,
        text_contractor_introduce_to_consumer_supplier: '',
        // benefits
        company_arrange_training: null,
        text_company_arrange_training: '',
        company_pay_for_training: null,
        text_company_pay_for_training: '',
        contractor_use_holiday_request_form: null,
        text_contractor_use_holiday_request_form: '',
        company_provide_vans: null,
        text_company_provide_vans: '',
        contractor_pay_for_company_vans: null,
        text_contractor_pay_for_company_vans: '',
        company_vans_how_used: null,
        text_company_vans_how_used: '',
        contractor_provided_corporate_benefits: null,
        text_contractor_provided_corporate_benefits: '',
        // Duties
        contractor_office_holder: null,
        text_contractor_office_holder: '',
        contractor_ltd_sole_trader: null,
        text_contractor_ltd_sole_trader: '',
        contractor_personal_service_required: null,
        text_contractor_personal_service_required: '',
        // working arrangement
        contractor_buy_equipment: null,
        text_contractor_buy_equipment: '',
        contractor_buy_materials: null,
        text_contractor_buy_materials: '',
        contractor_fund_any_other_cost: null,
        text_contractor_fund_any_other_cost: '',
        company_provide_ppe: null,
        text_company_provide_ppe: '',
        contractor_work_alongside_paye: null,
        text_contractor_work_alongside_paye: '',
        signature_sign: '',
        signature_date: ''
      },
      saving: false,
      updating: false,
    }
  },
  beforeMount() {
    if (this.notEmptyObject(this.health_check)) {
      this.cct = this.health_check;

      // Ensure the SignaturePad component is rendered before accessing its $refs
      this.$nextTick(() => {
        const canvasSign = this.$refs.signature_sign.$refs.signaturePad;
        const ctxSign = canvasSign.getContext('2d');
        
        const savedSignatureSign = new Image();
        savedSignatureSign.onload = () => {
          ctxSign.drawImage(savedSignatureSign, 0, 0);
        };
        savedSignatureSign.src = this.cct.signature_sign;
      });

      // Ensure the SignaturePad component is rendered before accessing its $refs
      this.$nextTick(() => {
        const canvasSign = this.$refs.signature_date.$refs.signaturePad;
        const ctxSign = canvasSign.getContext('2d');
        
        const savedSignatureSign = new Image();
        savedSignatureSign.onload = () => {
          ctxSign.drawImage(savedSignatureSign, 0, 0);
        };
        savedSignatureSign.src = this.cct.signature_date;
      });
    }
  },
  methods: {
    handleSignatureUpdated(field, imageData) {
        this.cct[field] = imageData;
      // $('#'+field+'_result').attr('src',"data:"+imageData);
      this.save_for_later();
    },
    save_for_later() {
      this.updating = true;
      this.cct.log_by_type = 'App\\Models\\Users\\User';
      this.cct.log_by_id = this.$store.state.auth.me.id;
      axios.patch(this.crmApiPath + 'company/health_check/' + this.cct.id, this.cct).then(() => {
        this.$bus.$emit('company_health_check::reload', {action: true});
        this.$bus.$emit('logs::reload', {action: true});
        this.updating = false;
      })
    },
    company_health_check_submit() {
      this.$refs.companyHealthCheck.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.companyHealthCheck);
        }
        else {
          this.saving = true;
          this.cct.log_by_type = 'App\\Models\\Users\\User';
          this.cct.log_by_id = this.$store.state.auth.me.id;
          this.cct.completed_date = this.$moment().format('YYYY-MM-DD HH:mm:ss');
          console.log(this.cct)
          axios.patch(this.crmApiPath + 'company/health_check/' + this.cct.id, this.cct).then(() => {
            this.$bus.$emit('company_health_check::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            this.saving = false;
          })
        }
      });
    }
  },
  watch: {
    'cct.company_right_of_control'(val) {
      if (val === 'No') {
        this.cct.text_company_right_of_control = 'N/A';
      }
      else {
        if (this.cct.text_company_right_of_control === 'N/A') {
          this.cct.text_company_right_of_control = ''
        }
      }
    },
    'cct.contractor_right_to_substitution'(val) {
      if (val === 'No') {
        this.cct.text_contractor_right_to_substitution = '';
        this.cct.pay_substitute_responsibility = null;
        this.cct.text_pay_substitute_responsibility = '';
        this.cct.company_right_to_reject_substitute = null;
        this.cct.text_company_right_to_reject_substitute = '';
      }
      else {
        this.cct.text_contractor_right_to_substitution = 'N/A';
      }
    },
    'cct.pay_substitute_responsibility'(val) {
      if (val === 'Contractor') {
        this.cct.text_pay_substitute_responsibility = 'N/A'
      }
      else {
        if (this.cct.text_pay_substitute_responsibility === 'N/A') {
          this.cct.text_pay_substitute_responsibility = ''
        }
      }
    },
    'cct.company_right_to_reject_substitute'(val) {
      if (val === 'Yes') {
        this.cct.text_company_right_to_reject_substitute = 'N/A'
      }
      else {
        if (this.cct.text_company_right_to_reject_substitute === 'N/A') {
          this.cct.text_company_right_to_reject_substitute = ''
        }
      }
    },
    'cct.contractor_set_hours'(val) {
      if (val === 'No') {
        this.cct.text_contractor_set_hours = 'N/A'
      }
      else {
        if (this.cct.text_contractor_set_hours === 'N/A') {
          this.cct.text_contractor_set_hours = ''
        }
      }
    },
    'cct.historic_contractor_sent_alternative_labour'(val) {
      if (val === 'Yes') {
        this.cct.text_historic_contractor_sent_alternative_labour = 'N/A'
      }
      else {
        if (this.cct.text_historic_contractor_sent_alternative_labour === 'N/A') {
          this.cct.text_historic_contractor_sent_alternative_labour = ''
        }
      }
    },
    'cct.contractors_engage_additional_support_own_cost'(val) {
      if (val === 'Yes') {
        this.cct.text_contractors_engage_additional_support_own_cost = 'N/A'
      }
      else {
        if (this.cct.text_contractors_engage_additional_support_own_cost === 'N/A') {
          this.cct.text_contractors_engage_additional_support_own_cost = ''
        }
      }
    },
    'cct.contractor_decline_work'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_decline_work = 'N/A'
      }
      else {
        if (this.cct.text_contractor_decline_work === 'N/A') {
          this.cct.text_contractor_decline_work = ''
        }
      }
    },
    'cct.company_carry_out_right_to_work_checks'(val) {
      if (val === 'Yes') {
        this.cct.text_company_carry_out_right_to_work_checks = 'N/A'
      }
      else {
        if (this.cct.text_company_carry_out_right_to_work_checks === 'N/A') {
          this.cct.text_company_carry_out_right_to_work_checks = ''
        }
      }
    },
    'cct.how_check_non_uk_right_to_work'(val) {
      if (val === 'R2W_Code') {
        this.cct.text_how_check_non_uk_right_to_work = 'N/A'
      }
      else {
        if (this.cct.text_how_check_non_uk_right_to_work === 'N/A') {
          this.cct.text_how_check_non_uk_right_to_work = ''
        }
      }
    },
    'cct.contractors_have_own_insurance'(val) {
      if (val === 'Yes') {
        this.cct.text_contractors_have_own_insurance = 'N/A'
      }
      else {
        if (this.cct.text_contractors_have_own_insurance === 'N/A') {
          this.cct.text_contractors_have_own_insurance = ''
        }
      }
    },
    'cct.contractors_invoice_for_work'(val) {
      if (val === 'Yes') {
        this.cct.text_contractors_invoice_for_work = 'N/A'
      }
      else {
        if (this.cct.text_contractors_invoice_for_work === 'N/A') {
          this.cct.text_contractors_invoice_for_work = ''
        }
      }
    },
    'cct.contractors_financial_risk'(val) {
      if (val === 'Yes') {
        this.cct.text_contractors_financial_risk = 'N/A'
      }
      else {
        if (this.cct.text_contractors_financial_risk === 'N/A') {
          this.cct.text_contractors_financial_risk = ''
        }
      }
    },
    'cct.contractor_pay_type'(val) {
      if (val === 'Price') {
        this.cct.text_contractor_pay_type = 'N/A'
      }
      else {
        if (this.cct.text_contractor_pay_type === 'N/A') {
          this.cct.text_contractor_pay_type = ''
        }
      }
    },
    'cct.contractor_contract_for_every_job'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_contract_for_every_job = 'N/A'
      }
      else {
        if (this.cct.text_contractor_contract_for_every_job === 'N/A') {
          this.cct.text_contractor_contract_for_every_job = ''
        }
      }
    },
    'cct.contractor_contract_for_every_site'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_contract_for_every_site = 'N/A'
      }
      else {
        if (this.cct.text_contractor_contract_for_every_site === 'N/A') {
          this.cct.text_contractor_contract_for_every_site = ''
        }
      }
    },
    'cct.contractor_contract_fixed_end_date'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_contract_fixed_end_date = 'N/A'
      }
      else {
        if (this.cct.text_contractor_contract_fixed_end_date === 'N/A') {
          this.cct.text_contractor_contract_fixed_end_date = ''
        }
      }
    },
    'cct.company_know_who_will_complete_work'(val) {
      if (val === 'No') {
        this.cct.text_company_know_who_will_complete_work = 'N/A'
      }
      else {
        if (this.cct.text_company_know_who_will_complete_work === 'N/A') {
          this.cct.text_company_know_who_will_complete_work = ''
        }
      }
    },
    'cct.contractor_notice_given'(val) {
      if (val === 'No_Notice' || val === 'No_Agency') {
        this.cct.text_contractor_notice_given = 'N/A'
      }
      else {
        if (this.cct.text_contractor_notice_given === 'N/A') {
          this.cct.text_contractor_notice_given = ''
        }
      }
    },
    'cct.contractor_work_for_other_companies'(val) {
      if (val === 'No') {
        this.cct.text_contractor_work_for_other_companies = 'N/A'
      }
      else {
        if (this.cct.text_contractor_work_for_other_companies === 'N/A') {
          this.cct.text_contractor_work_for_other_companies = ''
        }
      }
    },
    'cct.contractor_introduce_to_consumer_supplier'(val) {
      if (val === 'Worker_Engaged_By_Third_Party') {
        this.cct.text_contractor_introduce_to_consumer_supplier = 'N/A'
      }
      else {
        if (this.cct.text_contractor_introduce_to_consumer_supplier === 'N/A') {
          this.cct.text_contractor_introduce_to_consumer_supplier = ''
        }
      }
    },
    'cct.company_arrange_training'(val) {
      if (val === 'No') {
        this.cct.text_company_arrange_training = 'N/A'
        this.cct.company_pay_for_training = null;
        this.cct.text_company_pay_for_training = '';
      }
      else {
        if (this.cct.text_company_arrange_training === 'N/A') {
          this.cct.text_company_arrange_training = ''
        }
      }
    },
    'cct.company_pay_for_training'(val) {
      if (val === 'No') {
        this.cct.text_company_pay_for_training = 'N/A'
      }
      else {
        if (this.cct.text_company_pay_for_training === 'N/A') {
          this.cct.text_company_pay_for_training = ''
        }
      }
    },
    'cct.contractor_use_holiday_request_form'(val) {
      if (val === 'No') {
        this.cct.text_contractor_use_holiday_request_form = 'N/A'
      }
      else {
        if (this.cct.text_contractor_use_holiday_request_form === 'N/A') {
          this.cct.text_contractor_use_holiday_request_form = ''
        }
      }
    },
    'cct.company_provide_vans'(val) {
      if (val === 'No') {
        this.cct.text_company_provide_vans = 'N/A'
        this.cct.contractor_pay_for_company_vans = null;
        this.cct.text_contractor_pay_for_company_vans = '';
        this.cct.company_vans_how_used = null;
        this.cct.text_company_vans_how_used = '';
      }
      else {
        if (this.cct.text_company_provide_vans === 'N/A') {
          this.cct.text_company_provide_vans = ''
        }
      }
    },
    'cct.contractor_pay_for_company_vans'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_pay_for_company_vans = 'N/A'
      }
      else {
        if (this.cct.text_contractor_pay_for_company_vans === 'N/A') {
          this.cct.text_contractor_pay_for_company_vans = ''
        }
      }
    },
    'cct.company_vans_how_used'(val) {
      if (val === 'Work') {
        this.cct.text_company_vans_how_used = 'N/A'
      }
      else {
        if (this.cct.text_company_vans_how_used === 'N/A') {
          this.cct.text_company_vans_how_used = ''
        }
      }
    },
    'cct.contractor_provided_corporate_benefits'(val) {
      if (val === 'No') {
        this.cct.text_contractor_provided_corporate_benefits = 'N/A'
      }
      else {
        if (this.cct.text_contractor_provided_corporate_benefits === 'N/A') {
          this.cct.text_contractor_provided_corporate_benefits = ''
        }
      }
    },
    'cct.contractor_office_holder'(val) {
      if (val === 'No') {
        this.cct.text_contractor_office_holder = 'N/A'
      }
      else {
        if (this.cct.text_contractor_office_holder === 'N/A') {
          this.cct.text_contractor_office_holder = ''
        }
      }
    },
    'cct.contractor_ltd_sole_trader'(val) {
      if (val === 'Limited_Company' || val === 'Sole_Trader' || val === 'Both') {
        this.cct.text_contractor_ltd_sole_trader = 'N/A'
      }
      else {
        if (this.cct.text_contractor_ltd_sole_trader === 'N/A') {
          this.cct.text_contractor_ltd_sole_trader = ''
        }
      }
    },
    'cct.contractor_personal_service_required'(val) {
      if (val === 'No') {
        this.cct.text_contractor_personal_service_required = 'N/A'
      }
      else {
        if (this.cct.text_contractor_personal_service_required === 'N/A') {
          this.cct.text_contractor_personal_service_required = ''
        }
      }
    },
    'cct.contractor_buy_equipment'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_buy_equipment = 'N/A'
      }
      else {
        if (this.cct.text_contractor_buy_equipment === 'N/A') {
          this.cct.text_contractor_buy_equipment = ''
        }
      }
    },
    'cct.contractor_buy_materials'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_buy_materials = 'N/A'
      }
      else {
        if (this.cct.text_contractor_buy_materials === 'N/A') {
          this.cct.text_contractor_buy_materials = ''
        }
      }
    },
    'cct.contractor_fund_any_other_cost'(val) {
      if (val === 'Yes') {
        this.cct.text_contractor_fund_any_other_cost = 'N/A'
      }
      else {
        if (this.cct.text_contractor_fund_any_other_cost === 'N/A') {
          this.cct.text_contractor_fund_any_other_cost = ''
        }
      }
    },
    'cct.company_provide_ppe'(val) {
      if (val === 'No') {
        this.cct.text_company_provide_ppe = 'N/A'
      }
      else {
        if (this.cct.text_company_provide_ppe === 'N/A') {
          this.cct.text_company_provide_ppe = ''
        }
      }
    },
    'cct.contractor_work_alongside_paye'(val) {
      if (val === 'No') {
        this.cct.text_contractor_work_alongside_paye = 'N/A'
      }
      else {
        if (this.cct.text_contractor_work_alongside_paye === 'N/A') {
          this.cct.text_contractor_work_alongside_paye = ''
        }
      }
    }
  }
}
</script>

<style lang="scss">
.health_check {
  .record_card_body p {
    padding-top: 0;
  }

  /* PRETTY CHECKBOX MULTI LINE */
  .pretty {
    white-space:   inherit;
    margin-bottom: 1em;
    display:       block;
    height:        auto;

    .state {
      label {
        text-indent:  0;
        padding-left: 2rem;
        line-height:  1.2;

        &:after, &:before {
          top: 0;
        }
      }
    }
  }

  .validationError {
    background: lighten($red, 50%);
  }

  .vvERROR {
    margin-bottom: 20px;
  }

  .form-input.disabled, .orcaDateTimePicker .field-input.disabled {
    background: #eaeaea;
    background: linear-gradient(to top, #eaeaea 100%, transparent 12px) !important;
    box-shadow: 0 1px 0 0 #d1d1d1 !important;
  }
}



.signature-container {
  display: flex;
  flex-wrap: wrap; /* Elastyczne zawijanie wierszy */
}

.signature-wrapper {
  flex: 0 0 calc(50% - 5px); /* Ustawienie szerokości na 50% z odstępem 5px */
  margin-bottom: 10px; /* Opcjonalny odstęp między podpisami */
}

</style>
